import $ from 'jquery';
import 'fullpage.js';

//jQuery usage is here because of fullPage invocation

export default (state) => {
  const $body = $('.page');

  if (typeof state == 'undefined') {
    state = $body.hasClass('page--opened-modal');
  }

  if (state) {
    $body.data('top', $(window).scrollTop());
    $body.addClass('page--opened-modal');
  } else {
    $body.removeClass('page--opened-modal');
    $(window).scrollTop($body.data('top'));
  }

  if ($.fn.fullpage && $.fn.fullpage.setAllowScrolling) {
    $.fn.fullpage.setAllowScrolling(!state);
    $.fn.fullpage.setKeyboardScrolling(!state);
  }
}
